import { render } from "./SynodicOrbitObjectsCustomInput.vue?vue&type=template&id=308f8228"
import script from "./SynodicOrbitObjectsCustomInput.vue?vue&type=script&lang=js"
export * from "./SynodicOrbitObjectsCustomInput.vue?vue&type=script&lang=js"

import "./SynodicOrbitObjectsCustomInput.vue?vue&type=style&index=0&id=308f8228&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__